/**
 * Tell PostHog who is using the app, so a replay and a crash report name a
 * person rather than an id.
 *
 * Impersonation is passed through: the session belongs to the staff member,
 * because that is what "as if done by them" means, but every event carries the
 * admin who is really driving. A recording labelled only with the staff
 * member's name would misattribute an admin's actions to them
 * (docs/IMPERSONATION.md).
 */
import { useEffect } from 'react'
import { identifyAnalyticsUser } from '@/adapters/observability/posthog.client'

interface Me {
  userId: string
  organizationId: string
  name: string
  email: string
  impersonation?: { byName: string } | null
}

export function useIdentify(me: Me | undefined): void {
  const id = me?.userId
  const organizationId = me?.organizationId
  const name = me?.name
  const email = me?.email
  const impersonatedBy = me?.impersonation?.byName

  useEffect(() => {
    if (!id || !organizationId || !name || !email) {
      identifyAnalyticsUser(null)
      return
    }
    identifyAnalyticsUser({ id, organizationId, name, email, impersonatedBy })
  }, [id, organizationId, name, email, impersonatedBy])
}
